import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { KhenThuongAPI } from '../../services/feature-api';
import { PageShell, Icon, Avatar, HanhTrinh, KetQuaHoSo, NhanMotTrongHai, Hoac, YeuCauTuyenSi, fmtTien, fmtNgay, tenPhuongTien } from './khen-thuong-shared';

// /khenthuong/du-lich-2026/tinh-trang — hồ sơ đã nộp (dl_2026_detail) + số liệu HIỆN NAY (DS duyệt, F1 cao nhất) để tự theo dõi.
// "Lúc nộp" = cột ds_hien_tai / ty_le_f1 chốt khi đăng ký; "Hiện nay" = BE tính lại mỗi lần mở trang.

const Dong = ({ label, value, strong }) => (
  <div className="flex items-center justify-between py-1.5 border-b border-dashed border-gray-100 last:border-0 gap-3">
    <span className="text-[13px] text-gray-500 flex-shrink-0">{label}</span>
    <span className={`text-[13px] text-right text-gray-900 ${strong ? 'font-black' : 'font-semibold'}`}>{value}</span>
  </div>
);

const DuLich2026TrangThai = ({ accessToken, userInfo, onLogout, totalPoints, onRefreshPoints }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!accessToken) return;
    setLoading(true); setError('');
    const r = await KhenThuongAPI.getCuaToi(accessToken);
    if (r.success) setData(r.data);
    else setError(r.error || 'Không tải được hồ sơ');
    setLoading(false);
  }, [accessToken]);

  useEffect(() => { load(); }, [load]);

  const hoSo = data?.hoSo;
  const user = data?.user;
  const chienDich = data?.chienDich;
  const hienNay = data?.hienNay;
  const mo = chienDich?.tinhTrang === 'mo';

  const dsCamKet = Number(hoSo?.dsCamKet) || 0;
  const dsHienNay = Number(hienNay?.dsHienTai) || 0;
  const pct = dsCamKet > 0 ? Math.min(100, Math.round((dsHienNay / dsCamKet) * 100)) : 0;
  const f1 = hienNay?.f1CaoNhat && Number(hienNay.f1CaoNhat.ds) > 0 ? hienNay.f1CaoNhat : null;
  const tyLe = hienNay?.tyLe;
  const nguong = hienNay?.nguongF1 ?? 1.5;
  // BE so số thô: DS > 1,5 × F1 (bằng = chưa đạt); DS ≥ 100tr (hạ từ 200tr 02/11/2026) — 2 điều kiện gộp thành bước 2 hành trình
  const datF1 = hienNay?.datF1 ?? true;
  const datDs200 = !!hienNay?.datDs200;
  const dsToiThieu = hienNay?.dsToiThieu ?? 100000000;

  return (
    <PageShell userInfo={userInfo} onLogout={onLogout} totalPoints={totalPoints} onRefreshPoints={onRefreshPoints} title="Tình trạng Du lịch 2026">
      <div className="px-3 pt-3 space-y-3">
        {loading && <p className="text-center text-gray-400 text-sm py-8">Đang tải...</p>}
        {error && <div className="rounded-xl bg-red-50 border border-red-200 text-red-700 text-[13px] px-3 py-2">{error}</div>}

        {data && !hoSo && (
          <div className="rounded-2xl bg-white border border-gray-200 px-4 py-6 text-center shadow-sm">
            <Icon name="luggage" size={44} className="text-gray-400" />
            <p className="mt-2 text-[16px] font-black text-gray-800">Bạn chưa đăng ký Du lịch 2026</p>
            <p className="text-[13px] text-gray-500 mt-1">
              {mo ? `Hạn đăng ký đến ${fmtNgay(chienDich?.ketThucDk)}` : 'Chiến dịch đã đóng đăng ký'}
            </p>
            {mo && (
              <button type="button" onClick={() => navigate('/khenthuong/du-lich-2026/dang-ky')}
                      className="mt-4 w-full rounded-xl bg-red-600 text-white py-3 text-[15px] font-black shadow-md">
                Đăng ký + cam kết doanh số
              </button>)}
          </div>
        )}

        {hoSo && (
          <>
            <div className="rounded-2xl px-4 py-4 text-white shadow-md" style={{ background: 'linear-gradient(135deg, #7F1D1D, #DC2626 60%, #F59E0B)' }}>
              <div className="flex items-center gap-3">
                <Avatar src={user?.avatar} name={user?.facebook} size={56} />
                <div className="min-w-0">
                  <p className="text-[17px] font-black leading-tight truncate">{user?.codeFacebook}</p>
                  <p className="text-[12px] text-white/80">Mã đăng ký <span className="font-black text-white tracking-wider">{hoSo.maDangKy}</span></p>
                </div>
              </div>
              <button type="button" onClick={() => navigate('/khenthuong/du-lich-2026/chuc-mung')}
                      className="mt-3 w-full rounded-xl bg-white/95 text-red-700 py-2.5 text-[14px] font-black flex items-center justify-center gap-1 shadow">
                <Icon name="celebration" size={18} />Xem lại màn hình đăng ký
              </button>
            </div>

            {/* Kết quả nổi bật + hành trình (cùng 2 khối với thẻ ngoài /khenthuong) */}
            <KetQuaHoSo hoSo={hoSo} batDauDuyet={chienDich?.batDauDuyet} ketThucDuyet={chienDich?.ketThucDuyet} />
            <div className="rounded-2xl bg-white border border-gray-200 shadow-sm px-4 py-4">
              <p className="text-[11px] font-bold text-gray-500 uppercase tracking-wide mb-2">Hành trình của bạn</p>
              <HanhTrinh trangThai={hoSo.trangThai} duDkDoanhSo={hienNay?.duDk} batDauDuyet={chienDich?.batDauDuyet} ketThucDuyet={chienDich?.ketThucDuyet} size="lg" />
            </div>

            <NhanMotTrongHai />
            {/* Yêu cầu doanh số: tiến độ so với cam kết + so với F1 cao nhất */}
            <div className="rounded-2xl bg-white border border-gray-200 shadow-sm px-4 py-4">
              <p className="text-[12px] font-bold text-gray-500 uppercase tracking-wide">Doanh số 2026 đã duyệt / cam kết</p>
              <p className="mt-1 text-[26px] font-black text-gray-900 leading-none">{fmtTien(dsHienNay)}</p>
              <p className="text-[12px] text-gray-500 font-semibold">cam kết {fmtTien(dsCamKet)}</p>
              <div className="mt-2 h-3 rounded-full bg-gray-200 overflow-hidden">
                <div className={`h-full rounded-full ${pct >= 100 ? 'bg-emerald-500' : 'bg-red-500'}`} style={{ width: `${pct}%` }} />
              </div>
              <p className={`mt-1 text-[13px] font-black ${pct >= 100 ? 'text-emerald-700' : 'text-red-700'}`}>{pct}% mục tiêu</p>
              <p className={`mt-1.5 flex items-center gap-1 text-[12px] font-bold ${datDs200 ? 'text-emerald-700' : 'text-amber-700'}`}>
                <Icon name={datDs200 ? 'check_circle' : 'warning'} size={16} />{datDs200 ? 'Đã đạt' : 'Chưa đạt'} mức tối thiểu {fmtTien(dsToiThieu)}
              </p>
            </div>

            {/* So với F1 cao nhất */}
            <div className={`rounded-2xl border px-4 py-3 ${datF1 ? 'bg-emerald-50 border-emerald-300' : 'bg-amber-50 border-amber-300'}`}>
              <p className={`flex items-center gap-1 text-[14px] font-black ${datF1 ? 'text-emerald-800' : 'text-amber-800'}`}>
                <Icon name={datF1 ? 'check_circle' : 'warning'} size={20} />
                {datF1 ? 'Đã vượt' : 'Chưa vượt'} {nguong.toLocaleString('vi-VN')} lần F1 cao nhất
              </p>
              {f1
                ? <p className={`text-[12px] font-semibold mt-0.5 ${datF1 ? 'text-emerald-700' : 'text-amber-700'}`}>
                    Hiện gấp <b className="text-[15px]">{tyLe == null ? '—' : tyLe.toLocaleString('vi-VN')}</b> lần {f1.codeFacebook} ({fmtTien(f1.ds)})
                    {hoSo.tyLeF1 != null && <span className="text-gray-500"> · lúc nộp {Number(hoSo.tyLeF1).toLocaleString('vi-VN')} lần</span>}
                  </p>
                : <p className="text-[12px] font-semibold text-emerald-700 mt-0.5">Chưa có F1 nào có doanh số duyệt năm 2026.</p>}
            </div>
            <Hoac />
            <YeuCauTuyenSi tuyenSi={hienNay?.tuyenSi} so="★" />

            <div className="rounded-2xl bg-white border border-gray-200 shadow-sm px-4 py-3">
              <p className="text-[12px] font-bold text-gray-500 uppercase tracking-wide mb-1">Hồ sơ đã nộp</p>
              <Dong label="Ngày đăng ký" value={fmtNgay(String(hoSo.createdAt || '').slice(0, 10))} />
              <Dong label="Doanh số lúc nộp" value={fmtTien(hoSo.dsHienTai)} />
              <Dong label="Phương tiện" value={tenPhuongTien(hoSo.phuongTien)} />
              {hoSo.duyetLuc && <Dong label="Ngày có kết quả" value={fmtNgay(String(hoSo.duyetLuc).slice(0, 10))} />}
              <Dong label="Lịch xét duyệt" value={`${fmtNgay(chienDich?.batDauDuyet)} → ${fmtNgay(chienDich?.ketThucDuyet)}`} strong />
            </div>

            <button type="button" onClick={() => navigate('/doanh-so')}
                    className="w-full rounded-xl bg-white border-2 border-red-600 text-red-700 py-3 text-[14px] font-bold flex items-center justify-center gap-1">
              <Icon name="trending_up" size={18} />Cập nhật doanh số T1→T12
            </button>
          </>
        )}
      </div>
    </PageShell>
  );
};

export default DuLich2026TrangThai;
